import type { Recommendation } from '../types/case';

interface Props {
  recommendations: Recommendation[];
}

/**
 * Surfaces the most recent active assessment's reasoning as the mediator's
 * focus for the session. Falls back silently if there is none.
 *
 * Terminology note: the engine's API objects are still named
 * `recommendations`, but user-facing copy uses assess/surface/mutuality
 * language — never "recommend" (see CLAUDE.md).
 */
export function SurfacedFocus({ recommendations }: Props) {
  const latest = recommendations
    .filter((r) => r.status !== 'superseded' && r.status !== 'expired')
    .sort((a, b) => new Date(b.generated_at).getTime() - new Date(a.generated_at).getTime())[0];

  if (!latest) return null;

  return (
    <section className="card p-4">
      <div className="section-label">Surfaced focus</div>
      <p className="mt-2 text-sm text-gray-800">{latest.reasoning}</p>
      {latest.risk_factors.length > 0 && (
        <div className="mt-3">
          <div className="text-xs font-medium uppercase tracking-wider text-gray-500">
            Risk factors
          </div>
          <ul className="mt-1 list-disc pl-5 text-sm text-gray-700">
            {latest.risk_factors.map((r, i) => (
              <li key={i}>{r}</li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
}
